import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Divider,
} from "@mui/material";

export default function ConfirmDialog({
  open,
  title = "Are you sure?",
  content = "This action cannot be undone.",
  onClose,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "error",
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          padding: 3,
          minHeight: 220,
        },
      }}
    >
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: "16px",
            color: theme.palette.grey[800],
            marginBottom: 5,
          }}
        >
          {content}
        </Typography>
      </Box>

      <DialogActions sx={{ justifyContent: "flex-end", marginTop: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={confirmColor}
          sx={{ minWidth: "100px" }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
